import { render, staticRenderFns } from "./ModelBase.vue?vue&type=template&id=22a5b0ee&scoped=true"
import script from "./ModelBase.vue?vue&type=script&lang=js"
export * from "./ModelBase.vue?vue&type=script&lang=js"
import style0 from "./ModelBase.vue?vue&type=style&index=0&id=22a5b0ee&prod&lang=css"
import style1 from "./ModelBase.vue?vue&type=style&index=1&id=22a5b0ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a5b0ee",
  null
  
)

export default component.exports